module.exports = __webpack_public_path__ + "img/mom.e438e6e4.svg";